/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PersonDataDetailsFormEditableAliases {
  ACTION_PRINT = 'action-print',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_1 = 'autocomplete-1',
  AUTOCOMPLETE_ESTADO = 'autocomplete-estado',
  AUTOCOMPLETE_ESTADO_EMISSOR = 'autocomplete-estado-emissor',
  AUTOCOMPLETE_MUNICIPIO = 'autocomplete-municipio',
  AUTOCOMPLETE_PAISES = 'autocomplete-paises',
  BUTTON_FECHAR = 'button-fechar',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_PERSON_DATA = 'contextual-bar-person-data',
  DATE_FIELD_DATA_EMISSAO = 'date-field-data-emissao',
  DATE_FIELD_NASCIMENTO = 'date-field-nascimento',
  ESTADO_CIVIL_FETCH = 'estado-civil-fetch',
  ESTADO_CIVIL_MAPPER = 'estado-civil-mapper',
  ESTADO_FETCH = 'estado-fetch',
  FIELD_BAIRROS = 'field-bairros',
  FIELD_CELULAR = 'field-celular',
  FIELD_CEP = 'field-cep',
  FIELD_COMPLEMENTO = 'field-complemento',
  FIELD_CPF = 'field-cpf',
  FIELD_DATA_EMISSAO = 'field-data-emissao',
  FIELD_EMAIL = 'field-email',
  FIELD_ENDERECO = 'field-endereco',
  FIELD_ESTADOS_CIVIL = 'field-estados-civil',
  FIELD_ESTADOS_EMISSOR = 'field-estados-emissor',
  FIELD_FETCH_ESTADOS = 'field-fetch-estados',
  FIELD_FETCH_MUNICIPIO = 'field-fetch-municipio',
  FIELD_FILE_UPLOADER = 'field-fileUploader',
  FIELD_GENEROS = 'field-generos',
  FIELD_NASCIDO_VIVO = 'field-nascido-vivo',
  FIELD_NOME = 'field-nome',
  FIELD_NOME_MAE = 'field-nome-mae',
  FIELD_NOME_PAI = 'field-nome-pai',
  FIELD_NOME_SOCIAL = 'field-nome-social',
  FIELD_NR_TERMO_ALT = 'field-nr-termo-alt',
  FIELD_NUMERO = 'field-numero',
  FIELD_ORGAO_EMISSOR = 'field-orgao-emissor',
  FIELD_PAISES = 'field-paises',
  FIELD_RG = 'field-rg',
  FIELD_RG_ESTRANGEIRO = 'field-rg-estrangeiro',
  FIELD_SUS = 'field-sus',
  FIELD_TELEFONE = 'field-telefone',
  FIELD_TOAST = 'field-toast',
  FIELDSET_ANEXOS = 'fieldset-anexos',
  FIELDSET_EDITABLES = 'fieldset-editables',
  FIELDSET_ENDERECO = 'fieldset-endereco',
  FIELDSET_ESTADO_EMISSOR = 'fieldset-estado-emissor',
  FIELDSET_NASCIMENTO = 'fieldset-nascimento',
  FILE_UPLOADER = 'file-uploader',
  GENDER_FETCH = 'gender-fetch',
  GENDER_MAPPER = 'gender-mapper',
  HPMS_CUSTOM_DIALOG = 'hpms-custom-dialog',
  INPUT_0 = 'input-0',
  INPUT_BAIRROS = 'input-bairros',
  INPUT_CEP = 'input-cep',
  INPUT_COMPLEMENTO = 'input-complemento',
  INPUT_CPF = 'input-cpf',
  INPUT_EMAIL = 'input-email',
  INPUT_ENDERECO = 'input-endereco',
  INPUT_NASCIDO_VIVO = 'input-nascido-vivo',
  INPUT_NOME = 'input-nome',
  INPUT_NOME_MAE = 'input-nome-mae',
  INPUT_NOME_PAI = 'input-nome-pai',
  INPUT_NOME_SOCIAL = 'input-nome-social',
  INPUT_NUMERO = 'input-numero',
  INPUT_ORGAO_EMISSOR = 'input-orgao-emissor',
  INPUT_RG = 'input-rg',
  INPUT_RG_ESTRANGEIRO = 'input-rg-estrangeiro',
  INPUT_SUS = 'input-sus',
  LAYOUT_0 = 'layout-0',
  LOADER_0 = 'loader-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_EMISSOR = 'mapper-emissor',
  MAPPER_ESTADOS = 'mapper-estados',
  MAPPER_MUNICIPIO = 'mapper-municipio',
  MAPPER_PAISES = 'mapper-paises',
  MUNICIPIO_FETCH = 'municipio-fetch',
  PAIS_FETCH = 'pais-fetch',
  PANEL_0 = 'panel-0',
  PANEL_CARD = 'panel-card',
  PANEL_FORM = 'panel-form',
  PANEL_LOADER = 'panel-loader',
  PERSON_DATA_DETAILS_LAYOUT_EDITABLE = 'person-data-details-layout-editable',
  PERSON_DATA_FETCH_EDITABLE = 'person-data-fetch-editable',
  PERSON_DATA_FORM_EDITABLE = 'person-data-form-editable',
  PHONE_NUMBER_0 = 'phone-number-0',
  PHONE_NUMBER_1 = 'phone-number-1',
  SG_EMISORA_FETCH = 'sg-emisora-fetch',
  TEST_MUNICIPIO = 'test-municipio',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_ESTADO_EMISSOR = 'text-estado-emissor',
  TEXT_ESTADOS = 'text-estados',
  TEXT_OBRIGATORIO = 'text-obrigatorio',
  TEXT_PAISES = 'text-paises',
  TEXT_PROTOCOLO = 'text-protocolo',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { PersonDataDetailsFormEditableAliases };
